'use strict';

var _ = require('lodash');
var tooltipMarketTemplate = _.template(require('../templates/market-tooltip-template.html'));
var tooltipFlightTemplate = _.template(require('../templates/flight-tooltip-template.html'));
var DateRangeChartController = function DateRangeChartController($timeout, $rootScope, $scope, $filter, BrushSelectionFilter, formatter, analysisMetricService, dataProviderService, currentStateCriteriaService, userPreferencesService, constantsService, representationService, gridMaximizeConstants) {
  var defaultSelectionSize = 90;
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  var analysisMetric = analysisMetricService.getAnalysisMetric($scope.screen);
  var postDepartureMode = currentStateCriteriaService.isPostDeparture();
  $scope.isChartVisible = true;
  $scope.metrics = analysisMetric.getMetricValues($scope.mode);
  $scope.metricLabels = analysisMetric.getAvailableLabels($scope.mode);
  $scope.cogMenu = require('../config/cogMenu.json');
  $scope.screenState.metric = getInitialMetric();
  $scope.keepInSync = function () {
    $scope.cogMenu.options.defaults['no-submenu']['no-group'] = $scope.screenState.dataRepresentation;
  };
  if (typeof $scope.isViewportCollapsible === 'undefined') {
    $scope.isViewportCollapsible = true;
  }
  function getInitialSelection() {
    return [0, $scope.data.length];
  }
  function setMetrics(metric) {
    $scope.screenState.metric = metric || $scope.screenState.metric;
    var mode = postDepartureMode ? 'cabin-post-departure' : $scope.mode;
    var metricId = $scope.screenState.metric.id;
    $scope.metrics = analysisMetric.getMetricValues(mode, metricId, undefined, $scope.screenState.dimension);
  }

  // defaultSelectionSize === undefined : don't change the user's selection
  // departureDates === undefined : reload original departure dates
  function reloadChart(defaultSelectionSize, departureDates) {
    var metric = $scope.screenState.metric.id;
    var dataRepresentation = $scope.screenState.dataRepresentation;
    setMetrics();
    $scope.setLoadingMessage();
    return dataProviderService.getData({
      screen: $scope.screen,
      mode: $scope.mode,
      dataRepresentation: dataRepresentation,
      metric: metric,
      selectedReference: $scope.screenState.selectedReference,
      departureDates: departureDates,
      postDepartureMode: postDepartureMode
    }).then(function (chartData) {
      if (departureDates === undefined) {
        $scope.departureDates = chartData.originalDepartureDates;
      }
      if (defaultSelectionSize < chartData.data.length) {
        defaultSelectionSize = chartData.data.length;
      }
      $scope.data = chartData.data;
      $scope.renderChart($scope.data, defaultSelectionSize);
      if ($scope.sendDataUpdates) {
        $rootScope.$broadcast('dateRangeChart:dataChanged', $scope.data);
      }
    });
  }
  $scope.reloadChartsDuringMaximize = function (currentExpansionState, prevExpansionState, chartSelections) {
    var index = getIntendedExpansionIndex($scope.mode, $scope.screen);
    if (currentExpansionState[index] !== prevExpansionState[index] && !currentExpansionState[index] && _.isEqual(chartSelections, [null])) {
      $timeout(function () {
        $scope.initChart();
      }, 0);
    }
  };
  function getIntendedExpansionIndex(mode, screen) {
    if (screen === 'FLIGHT_SCREEN') {
      return 0;
    }
    return _.get(gridMaximizeConstants.MODE_INDEX_MAP, mode);
  }
  function clearThematicChartsSelection() {
    $scope.emitBrushFilter(undefined, true);
  }
  function triggerInitialFilter() {
    var dateRanges = $scope.data.length === 0 ? [] : rangesToDateArrays([[0, $scope.data.length]]);
    var brushFilter = new BrushSelectionFilter('dateRange', dateRanges);
    $scope.$emit('brush-filter:defaultBrush', brushFilter);
  }
  function findMetricLabel(id) {
    return _.find($scope.metricLabels, {
      id: id
    });
  }
  function getInitialMetric() {
    if ($scope.screenState.metric) {
      var metric = findMetricLabel($scope.screenState.metric.id);
      if (metric !== undefined) {
        return metric;
      }
    }
    var fromWorkflow = postDepartureMode ? 'flightAnalysisPostDeparture' : undefined;
    var userDefaultMetric = userPreferencesService.getUserSettingComponent('defaultMetric', fromWorkflow);
    return findMetricLabel(userDefaultMetric || analysisMetric.getDefault());
  }
  $scope.initChart = function () {
    postDepartureMode = currentStateCriteriaService.isPostDeparture();
    if ($scope.screen === gridMaximizeConstants.FLIGHT_SCREEN) {
      $scope.screenState.metric = getInitialMetric();
    }
    clearThematicChartsSelection();
    reloadChart(defaultSelectionSize, undefined).then(function () {
      if (_.isArray($scope.data) && $scope.data.length > 0) {
        $scope.setInitialSelection(getInitialSelection(), true);
      }
    }).then(triggerInitialFilter);
  };
  $scope.redrawChartWithNewFilter = function () {
    if ($scope.data !== undefined) {
      reloadChart(undefined, $scope.departureDates);
    }
  };
  $scope.togglePercentageModeDisabled = function (isDisabled) {
    if (isDisabled) {
      $scope.cogMenu.options.menus[0].disabled = true;
      if ($scope.screenState.dataRepresentation === 'percentage') {
        $rootScope.$broadcast('cog:date-range-chart', {
          val: ['absolute']
        });
      }
    } else {
      $scope.cogMenu.options.menus[0].disabled = false;
    }
  };
  $scope.changeMetricHandler = function (metric) {
    setMetrics(metric);
    if ($scope.screen === constantsService.MARKET_SCREEN && metric.id === 'demand') {
      $scope.togglePercentageModeDisabled(true);
    } else {
      $scope.togglePercentageModeDisabled(false);
    }
    reloadChart(undefined, $scope.departureDates);
  };
  function rangesToDateArrays(ranges) {
    var dataLength = $scope.data.length;
    return _.map(ranges, function (r) {
      var toIndex = r[1] > dataLength ? dataLength : r[1];
      return {
        from: $scope.data[r[0]].departureDateMoment,
        to: $scope.data[toIndex - 1].departureDateMoment
      };
    });
  }
  $scope.emitBrushFilter = function (ranges, silentSelectionClear) {
    var dateRanges = ranges !== undefined ? rangesToDateArrays(ranges) : [];
    var brushFilter = new BrushSelectionFilter('dateRange', dateRanges);
    brushFilter.barCount = $scope.data ? $scope.data.length : 0;
    if ($scope.sendDataUpdates) {
      brushFilter.ranges = ranges;
    }
    $scope.$emit('brush-filter:filterApplied', brushFilter, silentSelectionClear);
  };
  $scope.getLegendLabel = function (index) {
    return representationService.correctLabelForReference($scope.metrics[index], $scope.screenState.selectedReference, $scope.screen);
  };
  function dataFunction() {
    return $scope.data;
  }
  $scope.viewportReset = function () {
    $scope.resetViewportSelection($scope.data, defaultSelectionSize);
  };
  $scope.chartFormatters = {
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, representationService.getYAxisFormat($scope.screenState.dataRepresentation));
    },
    xAxisTickFormatter: formatter.momentTick('DAY_MONTH_SHORT_NAME', 'DAY_OF_MONTH', 'departureDateMoment', dataFunction),
    tooltipFormatter: function tooltipFormatter(d) {
      var isFlightScreen = $scope.screen === gridMaximizeConstants.FLIGHT_SCREEN;
      var tooltipModel = representationService.prepareTooltipModel($scope.metrics, d, {
        label: rmMomentFormat(d.departureDateMoment, 'DATE_USER_SETTINGS'),
        representation: $scope.screenState.dataRepresentation,
        selectedReference: $scope.screenState.selectedReference,
        postDeparture: isFlightScreen ? currentStateCriteriaService.isPostDeparture() : false
      }, $scope.screen);
      if (isFlightScreen) {
        return tooltipFlightTemplate(tooltipModel);
      } else {
        return tooltipMarketTemplate(tooltipModel);
      }
    }
  };
  $scope.isRepresentation = function (name) {
    return $scope.screenState.dataRepresentation === name;
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'date-range-chart-tooltip';
  $scope.viewportFormatters = {
    xAxisTickFormatter: formatter.momentMonthTick('MONTH', 'departureDateMoment', dataFunction)
  };
};
DateRangeChartController.$inject = ['$timeout', '$rootScope', '$scope', '$filter', 'BrushSelectionFilterFactory', 'FormatterService', 'AnalysisMetricService', 'DateRangeChartDataProviderService', 'CurrentStateCriteriaService', 'UserPreferencesService', 'DataRetrieverConstantsService', 'DataRepresentationService', 'GridMaximizeConstants'];
module.exports = DateRangeChartController;